<template>
  <md-dialog
    :md-active.sync="isVisible"
    :md-backdrop="true"
    :md-close-on-esc="false"
    :md-click-outside-to-close="false"
  >
    <div id="top-bar">
      <md-dialog-title style="margin-bottom: 0px; padding: 0px">Export</md-dialog-title>
      <span @click="isVisible = !isVisible" class="hoverable" style="color: #9c27b0">Minimize</span>
    </div>

    <md-dialog-content>
      <div v-if="!inProgress && !isComplete">
        <md-progress-bar md-mode="indeterminate"></md-progress-bar>
        <div>Fetching records metadata...</div>
      </div>

      <div v-else-if="inProgress && meta.total">
        <div style="position: relative; height: 40px">
          <div style="width: 100%"><span :style="{
            width: `${progress}%`,
            position: 'relative',
            display: 'block',
            textAlign: 'right',
            right: '-16px',
            top: '-3px',
            fontSize: '16px',
            fontWeight: 700,
            color: '#9c27b0',
          }" id="percentage">{{Math.round(progress)}}%</span></div>
          <md-progress-bar md-mode="determinate" :md-value="progress"></md-progress-bar>
        </div>
        <div style="font-weight: 500; " v-if="!isComplete">
          Downloaded {{commaNumber(records.length) || 0}} records of {{commaNumber(meta.total)}}.
        </div>
        <div v-else>Download complete!</div>
      </div>

      <div v-else-if="inProgress && !meta.total">
        <md-progress-bar v-if="!isComplete" md-mode="indeterminate"></md-progress-bar>
        <md-progress-bar v-if="isComplete" md-mode="determinate" :md-value="100"></md-progress-bar>
        <div v-if="!isComplete">
          Downloaded {{commaNumber(records.length) || 0}} records of many.
        </div>
        <div v-else>Download complete!</div>
      </div>
    </md-dialog-content>

    <md-dialog-actions>
      <vue-csv-downloader v-if="isComplete"
        :data="records"
        :download-name="filename"
        :fields="fields">
        Download
      </vue-csv-downloader>
      <md-button class="md-accent" @click="close()">Cancel</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import VueCsvDownloader from 'vue-csv-downloader';
import { commaNumber, formatAmount, formatToken } from '../utils/Formatter.util';

export default {
  name: 'export-modal',
  props: ['fields', 'onStart', 'onFetchData', 'specialPhones'],
  components: {
    VueCsvDownloader,
  },
  async updated() {
    if (this.isVisible && !this.inProgress) {
      if (this.onStart) {
        this.meta = await this.onStart();
      }
      this.inProgress = true;
      this.loadData();
    }
  },
  computed: {
    records() {
      return this.payload;
    },
    progress() {
      return this.meta.total ? (this.payload.length / this.meta.total) * 100 : 0;
    },
  },
  data() {
    return {
      isVisible: false,
      page: 1,
      meta: {
        total: 0,
        pages: 0,
      },
      isComplete: false,
      inProgress: false,
      isCancelled: false,
      payload: [],
      snackBar: {
        show: false,
        message: null,
      },
      filename: 'export',
    };
  },
  watch: {
    inProgress(val) {
      this.$emit('progressChange', val);
    },
  },
  methods: {
    commaNumber,
    getExportFileName() {
      const filename = this.$parent.getExportFileName();
      this.filename = filename;
    },
    open() {
      this.isVisible = true;
      this.isCancelled = false;

      // Only reset if there's no export already running/completed
      if (!this.inProgress && !this.isComplete) {
        this.page = 1;
        this.isComplete = false;
        this.meta = {};
        this.payload = [];
      }
    },
    close() {
      this.isVisible = false;
      this.page = 1;
      this.isComplete = false;
      this.meta = {};
      this.payload = [];
      this.inProgress = false;
      this.isCancelled = true;
    },

    formatVendResponse(data) {
      if (data.order_id) {
        data.ref = data.ref ? data.ref.toLocaleString('fullwide', { useGrouping: false }) : null;
        data.order_id = `'${data.order_id}`;
        data.meter_no = `'${data.meter_no}`;
        if (data.vendResponse) {
          data.rct_num = data.vendResponse.rct_num;
          data.units = data.vendResponse.units;
          data.amt = data.vendResponse.amt;
          data.amt_electricity = data.vendResponse.amt_electricity;
          data.tax = data.vendResponse.tax;
          data.debt = `'${formatAmount(data.vendResponse.debt)}`;
          data.token = `'${formatToken(data.vendResponse.token)}`;
          delete data.vendResponse;
        }
      } else if (data.customer) {
        data.name = data.customer.name || null;
        data.email = data.customer.email || null;
        data.phone = `"${data.customer.phone}"` || null;
        delete data.customer;
      } else {
        const phone = data.user ? data.user.phone : data.phone;
        const customerName = data.facility
          ? data.facility.owner
          : data.user
            ? data.user.name
            : phone;

        data.Phone = phone || null;
        data.Customer_name = customerName;
        data.Meter = `"${data.meter}"`;
        data.Account_name = `"${data.acc_name}"`;
        data.Account_num = `"${data.acc_num}"`;
        data.Bank = `"${data.bank}"`;
        data.ID = `"${data.id}"`;
        data.Disco = `"${data.disco}"`;
        data.Bank_code = `"${data.bank_code}"`;
        data.Reference = `"${data.ref}"`;
      }
    },

    async loadData() {
      const donwloadLimit = 90;
      const data = await this.$parent
        .fetchData(this.page, donwloadLimit);

      await data.rows.forEach(this.formatVendResponse);

      if (this.isCancelled) return; // bail out before touching state again

      if (!data.rows.length) {
        this.getExportFileName();
        this.isComplete = true;
        return;
      }

      // if (this.isVisible) {
      this.payload = [...this.payload, ...data.rows];
      this.inProgress = true;
      this.meta.total = data.count;
      this.page = this.page + 1;
      this.loadData();
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: #edf2f7;
  color: white;
}
.md-dialog /deep/.md-dialog-container {
  min-width: 30%;
}

.hoverable {
  opacity: 0.8;
  transition: all .25s ease-in;
}

.hoverable:hover {
  opacity: 1;
  cursor: pointer;
}

#top-bar {
  padding: 24px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
